import { useCallback, useEffect, useRef } from 'react';

import { FetchResult } from '@apollo/client';

import { computeShipmentConversion } from '../helpers';
import {
  CalculateBasicRateResponse,
  CalculateBasicRateVariables,
  ICurrency
} from '../types';

type Args = {
  proposalId?: string;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  policyCurrency: ICurrency;
  calcRate: (
    variables?: CalculateBasicRateVariables
  ) => Promise<FetchResult<CalculateBasicRateResponse>>;
};

export function useHydrateMarineFromQuery({
  proposalId,
  setFieldValue,
  policyCurrency,
  calcRate
}: Args) {
  const hasHydrated = useRef(false);

  useEffect(() => {
    hasHydrated.current = false;
  }, [proposalId]);

  const recalcPolicyCurrency = useCallback(
    async (sumPerShipmentCurrency: string, sumPerShipment: number) => {
      try {
        const { rate, inPolicy } = await computeShipmentConversion({
          sumPerShipment: sumPerShipment ?? 0,
          sumPerShipmentCurrency: sumPerShipmentCurrency,
          policyCurrency,
          calcRate
        });
        setFieldValue('marineDetails.sumPerShipmentRate', rate);
        setFieldValue('marineDetails.sumPerShipmentPolicyCurrency', inPolicy);
      } catch {
        setFieldValue('marineDetails.sumPerShipmentRate', 0);
        setFieldValue('marineDetails.sumPerShipmentPolicyCurrency', 0);
      }
    },
    []
  );

  return {
    recalcPolicyCurrency
  };
}
